import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=35dd793e&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=35dd793e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd793e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35dd793e')) {
      api.createRecord('35dd793e', component.options)
    } else {
      api.reload('35dd793e', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=35dd793e&scoped=true&", function () {
      api.rerender('35dd793e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24dGlewkPm8C3/JS/comp/DateRangeExt.vue"
export default component.exports